var _rect, _path, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgStatusAway = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 12,
  height: 12,
  fill: "none",
  viewBox: "0 0 12 12",
  ref: ref
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 11,
  height: 11,
  x: 0.5,
  y: 0.5,
  fill: "var(--supernova-core)",
  rx: 5.5
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "currentcolor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M6 3.5V6l2.5 1"
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  width: 11,
  height: 11,
  x: 0.5,
  y: 0.5,
  stroke: "currentcolor",
  rx: 5.5
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgStatusAway);
export default ForwardRef;